import {
  ASSISTANT_REDUCED_MOTION_MEDIA_QUERY,
  ASSISTANT_SMALL_SCREEN_MEDIA_QUERY,
} from '@/constants/assistant';

function matchesMediaQuery(query: string): boolean {
  return typeof window.matchMedia === 'function' && window.matchMedia(query).matches;
}

export function isSmallScreen(): boolean {
  return matchesMediaQuery(ASSISTANT_SMALL_SCREEN_MEDIA_QUERY);
}

export function prefersReducedMotion(): boolean {
  return matchesMediaQuery(ASSISTANT_REDUCED_MOTION_MEDIA_QUERY);
}
